const LOGO_BASE_FILL = '#90959D';
const LOGO_ACTIVE_FILL = '#000000';

const LOGO_PATHS = [
  'M13.1107 9.44531V11.6579C13.1107 12.4404 12.4748 13.075 11.6903 13.075H0.391371C0.0434831 13.075 -0.130898 12.6553 0.115159 12.4099L2.76365 9.76875C2.97125 9.5617 3.25315 9.44531 3.54684 9.44531H13.1116H13.1107Z',
  'M13.1099 4.45312V6.66532C13.1099 7.44775 12.474 8.08242 11.689 8.08242H4.45898L7.77397 4.77656C7.98157 4.56951 8.26303 4.45312 8.55672 4.45312H13.1103H13.1099Z',
  'M13.1104 0.390345V1.66274C13.1104 2.44518 12.4745 3.07985 11.6896 3.07985H9.4707L12.4435 0.114857C12.6895 -0.130555 13.1104 0.043369 13.1104 0.390345Z',
] as const;

const AssemblyMark = ({ fill }: { fill: string }) => (
  <svg
    className="absolute inset-0 h-full w-full"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {LOGO_PATHS.map((d) => (
      <path key={d} d={d} fill={fill} />
    ))}
  </svg>
);

interface AIAssistantLoadingIndicatorProps {
  /** Whether to animate the loading indicator */
  animate?: boolean;
  /** Additional CSS classes to apply to the loading indicator's container */
  className?: string;
  /** Size of the loading indicator in pixels */
  size?: number;
}

export const AIAssistantLoadingIndicator = ({
  animate = true,
  className = '',
  size = 14,
}: AIAssistantLoadingIndicatorProps) => {
  // Gray mark underneath, dark mark clipped on top. The clip wipes bottom →
  // top in one eased pass (see thinking-icon-fill) instead of snapping frames.
  const fillClassName = animate
    ? '[clip-path:inset(100%_0_0_0)] animate-thinking-icon-fill motion-reduce:animate-none motion-reduce:[clip-path:inset(0)]'
    : '[clip-path:inset(0)]';

  return (
    <div
      className={`relative inline-block ${className}`}
      style={{ width: size, height: size }}
    >
      <AssemblyMark fill={LOGO_BASE_FILL} />
      <div
        data-testid="thinking-icon-fill"
        className={`absolute inset-0 ${fillClassName}`}
      >
        <AssemblyMark fill={LOGO_ACTIVE_FILL} />
      </div>
    </div>
  );
};
